import { useMutation, useQueryClient } from '@tanstack/react-query';
import { VirtualMedicine } from '../types';
import { updateVirtualMedicine } from '../requests';

type UpdateVirtualMedicine = (id: string, data: Partial<VirtualMedicine>) => Promise<void>;

interface UseUpdateVirtualMedicineReturn {
  updateVirtualMedicine: UpdateVirtualMedicine;
  isLoading: boolean;
}

export const useUpdateVirtualMedicine = (): UseUpdateVirtualMedicineReturn => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ([id, update]: [string, Partial<VirtualMedicine>]) => updateVirtualMedicine(id, update),
    onSuccess: (_, [id]) => {
      queryClient.removeQueries(['virtual-medicine', id]);
    }
  });

  const updateVirtualMedicineCallback = async (id: string, data: Partial<VirtualMedicine>) => {
    await mutateAsync([id, data]);
  };

  return { updateVirtualMedicine: updateVirtualMedicineCallback, isLoading };
};
